/**
 * Custom error class for API-related errors.
 * Extends the built-in Error class to include additional details such as HTTP status codes and error-specific data.
 * This class is useful for handling errors that occur during API requests, providing more structured error information.
 *
 * @class ApiError
 * @extends {Error}
 */
export class ApiError extends Error {
  statusCode: number
  errorDetails: {
    data?: any
    timestamp?: string
    errorCode?: string
  }

  constructor(
    errorMessage: string,
    statusCode: number,
    errorDetails: {
      data?: any
      timestamp?: string
      errorCode?: string
    } = {},
  ) {
    super(errorMessage)
    this.name = "ApiError"
    this.statusCode = statusCode
    this.errorDetails = {
      ...errorDetails,
      timestamp: errorDetails.timestamp || new Date().toISOString(),
    }

    Object.setPrototypeOf(this, ApiError.prototype)
  }
}
